// @flow
import { createOaModalActions } from './createOaModalActionCreator';

const initialState = {
  showCreateOaModal: false,
  isLoading: false,
  isLoaded: false,
  data: {
    status: null,
    val: null
  },
  oaMobile: {
    isLoading: false,
    isLoaded: false,
    data: {
      status: null,
      val: null
    }
  }
};

const createOaModalReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createOaModalActions.SHOW_CREATE_OA_MODAL: {
      return { ...state, showCreateOaModal: action.payload };
    }
    case createOaModalActions.CREATE_OA: {
      return { ...state, ...action.payload };
    }
    case createOaModalActions.CHECK_OA_MOBILE: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};

export default createOaModalReducer;
